export const dim = () => {
    const w = Math.min(window.innerWidth, window.screen.width)
    const h = Math.min(window.innerHeight, window.screen.height, window.screen.availHeight, window.document.documentElement.clientHeight)

    return {
        w, h
    }
}